import http from '@/utils/http'

// Course
export const getCoursesByUser = (params: any) => http.get('my-courses', { params })

// Payment
export const getPayments = (params: any) => http.get('payments', { params })

// Upgrade
export const getUserUpgradeNotice = () => http.get('member-upgrade')

export const markUserUpgradeNotice = () => http.post('member-upgrade-read')

// Points
export const getPoints = (params: any) => http.get('user-point-records', { params })

// User
export const getWechatQrcodSource = () => http.get('wechat/qrcode/source')

export const patchUser = (params: any) => http.patch('user', params)

export const putIdentity = (params: any) => http.put('user/identity', params)

export const patchPrefectInfo = (params: any) => http.patch('users/perfect-information', params)

export const patchPrefectExtInfo = (params: any) => http.patch('users/perfect-ext-information', params)

export const patchImproveInfo = (params: any) => http.patch('users/improve-personalized-information', params)

// Account
export const mergeAccount = (params: any) => http.post('users/merge-account', params)

export const unbindWechat = () => http.patch('user/unbind-wechat')

export const changePhone = (params: any) => http.patch('user-phone', params)

export const postPhoneStatus = (params: any) => http.post('phone-status', params)

// Level
export const getUserLevel = () => http.get('member-center')

// Study Center
export const markLastStudy = (params: any) => http.post('student-last-study', params)

export const getStudentSemester = () => http.get('student-semesters')

export const setCourseTop = (params: any) => http.post('student-class-top', params)

export const getStudentCourses = (params: any) => http.get('student-classes', { params })

export const getStudentCoursesBySemester = (params: any) => http.get('student-courses', { params })

export const getStudentUniversities = () => http.get('student-universities')

export const changeStudentUniversity = (params: any) => http.post('student-university', params)

// 1v1 Study Courses
export const get1v1StudyCourses = (params: any) => http.get('v3/user-product-classes', { params })

export const get1v1StudyCourseById = (id: any, params: any) => http.get(`v3/user-product-classes/${id}`, { params })

export const top1v1UserCourse = (id: any) => http.get(`v3/user-classes-top/${id}`)

// Feedback
export const getFeedbackTypes = () => http.get('question-types')

export const postFeedback = (params: any) => http.post('feed-back', params)

// 微信合并账号
export const postWeChatMerge = (params: any) => http.post('users/merge-wechat-account', params)
export const getCourseFeedbackTypes = () => http.get('feedback/class/const')

export const getStudyFeedbackTypes = () => http.get('feedback/study/const')

export const postCourseFeedback = (params: any) => http.post('feedback/class/create', params)
// 学术诚信专项返回提交
export const postCourseFeedbackXszx = (params: any) => http.post('feedback/faith/create', params)

export const postStudyFeedback = (params: any, type: any) => type ? http.post('feedback/study/create2', params) : http.post('feedback/study/create', params)

// 获取订单转赠订单
export const getTransferOrder = (id: any) => http.get('get-transfer-order', { params: { trade_no: id } })
// 转赠订单确认
export const postSubmitTransferOrder = (params: any) => http.post('submit-transfer-order', params)

// 检测用户院校审批信息
export const checkUserUniversityApproval = () => http.post('user/university/check')

// 提交用户切换院校审批
export const postUserUniversityApprovel = (params: any) => http.post('user/university/change', params)

/**
 *
 * 学生待定课程
 *
 * @param params
 *
 * @returns
 */
export const getUserPendingCourses = (params: any) => {
  return http.get('student-pending-classes', {
    params
  })
}

// 获取邀请人信息
export const getInviter = () => http.get('invitations/inviter')

// 绑定邀请人
export const bindInviter = (params: any) => http.post('invitations', params)

// 推荐人列表
export const getUserInvations = (params: any) => http.get('invitations/invitee', { params })

// 获取返现明细
export const getCashbacks = (params: any) => http.get('cashbacks', { params })

// 获取返现明细详情
export const getCashbackDetail = (id: number) => http.get(`cashbacks/${id}`)

// 获取推荐人列表
export const getInvitationOptions = (params?: any) => http.get('invitations/options', { params })

// 检测邀请人ID
export const checkInvitater = (params: any) => http.get('invitations/check', { params })

// 兑换金额消耗狮子币
export const checkCoinCost = (params: any) => http.get('exchange-use-coins', { params })

// 狮子币兑换商品/赠送金额
export const postExchangeGoods = (params: any) => http.post('exchange-goods-submit', params)

// 兑换商品列表
export const getExchangeGoods = (params: any) => http.get('exchange-goods', { params })

// 兑换记录
export const getExchangeRecords = (params: any) => http.get('exchange-records', { params })

// 兑换商品详情
export const getExchangeGoodsDetail = (id: number) => http.get('exchange-goods-detail', { params: { id } })

// 获取注册授权确认详情
export const getPendingUserByInvitationCode = (code: string) => http.get(`pending-users/${code}`)

// 注册授权确认
export const postPendingUser = (code: string, params: any) => http.post(`pending-users/${code}/confirm`, params)
